import React, {useEffect} from 'react';
import { Helmet } from 'react-helmet';
import { TransitionProvider, TransitionViews } from "gatsby-plugin-transitions";
import Layout from '../components/Layout';
import { LanguageContext } from '../i18n';

// Sider som ikke har engelsk versjon (se gatsby-node.js)
const UNTRANSLATED = /^\/(404|dev-404-page|portfolio\/?$)/;

const LayoutIndex = ({ location, pageResources, children }) => {
  // Språket leses fra URL-en og ikke fra pageContext, så en utdatert page-data.json i cache ikke kan skjule språkvalget
  const lang = /^\/en(\/|$)/.test(location.pathname) ? 'en' : 'no';
  const pagePath = pageResources?.page?.path || location.pathname;
  const translated = !UNTRANSLATED.test(pagePath);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      let scroll = window.scrollY;

      if(scroll > 10) {
        document.getElementById("header").classList.add("shadow-sm");
      } else {
        document.getElementById("header").classList.remove("shadow-sm");
      }
    })
  }, [])
  return (
    <LanguageContext.Provider value={{ lang, path: location.pathname, translated }}>
    <Helmet htmlAttributes={{ lang }} />
    <Layout>
    <TransitionProvider
     location={location}
     enter={{
      opacity: 0,
      transform: "translate3d(0,20vh,0) scale3d(1, 1, 1) rotate(0deg)",
      config: {
        mass: 1,
        tension: 210,
        friction: 20,
        clamp: true
      }
    }}
     >
      <TransitionViews>
        {children}
      </TransitionViews>
    </TransitionProvider>
    </Layout>
    </LanguageContext.Provider>

  );
};

export default LayoutIndex;
